import { Component } from '@angular/core';
import { RoutesInstancesListComponent } from "../../../../components/admin-dashboard-component/admin-route-instance-component/admin-routes-instances-component/routes-instances-list-component/routes-instances-list-component";

@Component({
  selector: 'app-route-instance-list',
  imports: [RoutesInstancesListComponent],
  templateUrl: './route-instance-list.html',
  styleUrl: './route-instance-list.scss'
})
export class RouteInstanceList {

}
